﻿import { ConfiguratorDI, Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObject } from "@models/configurators/kb-object";
import { PartMaterial } from "@models/configurators/part-material";
import { PartOperation } from "@models/configurators/part-operation";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { IDummyNode } from "@models/configurators/kb-object";
import { UiObject } from "@models/configurators/ui-object";

export interface IManufactureObject {
    $properties: UiObject[];
    getIdentifyingProperty: () => string;
    _metadata: any[];
}

@Kbo(CToken.PartRev)
export class PartRev extends KbObject implements IManufactureObject {

    public $properties: UiObject[];
    public partNum: string;
    public revisionNum: string;
    public revShortDesc: string;
    public revDescription: string;
    public _metadata: any = {}
;

    public static getMetadataProperties() {
        return [];
    }

    private _materials: PartMaterial[];
    @Enumerable()
    public get materials(): PartMaterial[] {
        if (!this._materials) this._materials = [];
        return this._materials;
    }
    public set materials(val) {
        this._materials = val;
    }

    private _operations: PartOperation[];
    @Enumerable()
    public get operations(): PartOperation[] {
        if (!this._operations) this._operations = [];
        return this._operations;
    }
    public set operations(val) {
        this._operations = val;
    }
    public $materialsNode: IDummyNode;
    public $operationsNode: IDummyNode;

    constructor(kom: KbObjectManager, data?: any) {
        super(kom);
        this.$materialsNode = { id: this.id + "_materials", $type: "MaterialsNode", allowedChildren: () => [CToken.PartMaterial], getParent: () => this };
        this.$operationsNode = { id: this.id + "_operations", $type: "OperationsNode", allowedChildren: () => [CToken.PartOperation], getParent: () => this };
        this._metadata = {};

        for (const key in data) {
            const value = data[key];
            if (!Array.isArray(value)) (this as any)[key] = value;
        }
    }

    public getIdentifyingProperty() {
        return "partNum";
    }
}
